import { createContext } from "react";

export interface LanguageContextPayload {
    language?: string;
}

const LanguageContext = createContext<LanguageContextPayload>({});
export const LanguageContextProvider = LanguageContext.Provider;
export const LanguageContextConsumer = LanguageContext.Consumer;
